<template>
    <div class="home-slider">
            <vue-load-image>
            <div slot="image" alt="slight production o nama slika" class="background-image" :data-src="getSrcLink(currentID)" :style="{ backgroundImage: 'url(' + getSrcLink(currentID) + ')' }"></div>
            <div slot="preloader" class="lds-roller">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>          
            <div slot="error">učitavam sliku...</div>
            </vue-load-image>             
        <div class="swiper-slide-caption section-md">
            <div class="swiper-box">
                <div class="text-animation-container">
                    <transition name="slideInLeft" mode="out-in" appear>
                        <h3 :key="currentID">{{ getTextData("Title") }}</h3>
                    </transition>

                    <transition name="slideInRight" mode="out-in" appear>
                        <p :key="currentID">{{ getTextData("Description") }}</p>
                    </transition>
                </div>
                <div class="button-wrap">
                    <router-link :key="currentID" to="kontakt"><span class="icon mdi mdi-chevron-right"></span>Kontaktiraj nas</router-link>
                </div>                
            </div>
            <transition name="slideInUp" mode="out-in" appear>
                <div :key="currentID" class="animated-bg"></div>
            </transition>
        </div>   
            <div class="swiper-nav">
                <div class="swiper-nav-numbers">
                    <span class="swiper-pagination__fraction-index">{{getCurrentSwiperNumber(this.currentID)}}</span>
                    <span class="swiper-pagination__fraction-divider">/</span>
                    <span class="swiper-pagination__fraction-count">{{getCurrentSwiperNumber(this.news.length-1)}}</span>             
                </div>
                <div class="swiper-arrows">
                    <div class="swiper-button-prev" @click="swiperPrew()"></div>                     
                    <div class="swiper-button-next" @click="swiperNext()"></div>                                       
                </div>
            </div>            
    </div>
</template>

<script>
import axios from 'axios';
export default {
   data(){
        return{
            show:true,
            componentLoaded: false,
            currentID: 0,  
            news:'',
            onload: true,
            display: true,
        }
   },
   methods:{
        fetchData(){
            axios({
              method: 'get',
              url: this.apiPath +'news/readHomePageNews.php'
            })
            .then(function(response) {
                this.news = response.data;
                this.componentLoaded = true;                
            }.bind(this))
            .catch((error) => {
                console.log(error);
            });             
        },
        swiperNext(){
            this.currentID = this.currentID >= this.news.length-1 ? 0 : this.currentID + 1;
        },
        swiperPrew(){
            this.currentID = this.currentID <= 0 ? this.news.length-1 : this.currentID - 1;
        }          
   },
   computed: {
        getSrcLink: function() {
            return function(id) {
            if(! this.componentLoaded)
                return null;

             return this.dataPath + 'news_photos/' + this.news[id].Image;
            }
        },
        getTextData: function() {
            return function(item) {
                if(! this.componentLoaded)
                    return null;
                
                var returnValue = '';
                switch(item){
                    case "Title":
                        returnValue = this.news[this.currentID].Title;
                        break;
                    case "Description":
                        returnValue = this.news[this.currentID].Description;
                        break;                    
                }
                return returnValue;
            }
        },        
        getCurrentSwiperNumber: function() {
            return function(id){
                return id > 9 ? id+1 : '0'+(id+1);
            }
        }        
   },   
   created(){
       this.fetchData();
   },
   mounted: function () {
      window.setInterval(() => {
          this.swiperNext();
      }, 7000)
   }    
}
</script>

<style lang="scss">
.home-slider{
    position: relative;
    .vue-load-image{
        height: 500px;
    }
    .background-image{
        background-size: cover;
        white-space: nowrap;
        // max-width: calc(100% - 210px);  
        height: 500px;  
    }
    .swiper-slide-caption{
        position: absolute;
        top: 0;
        left: 10rem;
        max-width: 500px;
        width: 500px;
        z-index: 1;
        height: 500px;
        padding: 0;
        transition-duration: 400ms;
        overflow: hidden;

        .swiper-box{
            margin: 4rem 4rem 2rem 4rem;
                overflow: hidden;
            h3{
                text-transform: uppercase;
                font-size: 24px;
                color: #151515;
                font-weight: 100;
                transition-duration: 800ms;
            }    
            
            img{
                height: 200px;
            }
            p{
                font-family: "Roboto", -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, sans-serif;
                font-size: 15px;
                line-height: 1.6;
                font-weight: 400;
                letter-spacing: .075em;
                color: #777777;
                -webkit-text-size-adjust: none;
                -webkit-font-smoothing: subpixel-antialiased;
            }
            .button-wrap{
                position: absolute;
                bottom: 4rem;
                overflow: hidden;

                a{
                    padding: 30px 90px 30px 30px;
                    background-color: #080808;
                    border-color: #080808;
                    color:#fff;
                    position: relative;
                    overflow: hidden;
                    display: inline-block;                    
                    border: none;
                    font-weight: 900;
                    letter-spacing: 0.2em;
                    text-transform: uppercase;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    text-align: center;
                    cursor: pointer;
                    vertical-align: middle;
                    user-select: none;
                    transition: all .25s ease-in-out;   

                    &:hover{
                        color: #ffffff;
                        background-color: #718c26;
                        border-color: #718c26;  
                        span{
                            background-color: #51651a;  
                        }                      
                    }
                    span{
                        display: flex;
                        align-items: center;
                        position: absolute;
                        top: 0;
                        right: 0;
                        bottom: 0;
                        width: 68px;
                        font-size: 27px;
                        transition: inherit;
                        background: #292929;
                        color: #a7cf38;  
                        &::before{
                            content: "\f238"; 
                            position: absolute;
                            left: 0;
                            right: 0;                            
                        }                                 
                    }                   
                }
            }
        }
        .animated-bg{
            background: white;
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            z-index: -1;            
        }
    }

    .swiper-nav{
        position: absolute;
        bottom: 0;
        right: 0px;
        padding: 30px 60px 15px;
        z-index: 1;            
        background: #f7f7f7;

            .swiper-nav-numbers{
                position: relative;
                display: inline-block;
                vertical-align: bottom;
                .swiper-pagination__fraction-index{
                    font-size: 60px;
                    line-height: 1;
                    font-weight: 300;
                    color: rgba(21, 21, 21, 0.21);
                }
                .swiper-pagination__fraction-divider{
                    font-size: 24px;
                    line-height: 1.167;
                    letter-spacing: 0;
                    color: #a7cf38;
                }
                .swiper-pagination__fraction-count{
                    font-size: 24px;
                    line-height: 1.167;
                    letter-spacing: 0;
                    color: #a7cf38;
                }
            }
            .swiper-arrows{
                position: relative;
                margin-left: 2rem;
                display: inline-block;
                vertical-align: bottom;
                .swiper-button-prev, .swiper-button-next{
                    position: static;
                    width: 48px;
                    height: 48px;
                    top: auto;
                    left: auto;
                    font-size: 28px;
                    line-height: 46px;
                    transform: none;
                    color: #151515;
                    border: 1px solid #989898;
                    border-radius: 50%;
                    font-family: "Material Design Icons";  
                    display: inline-block;  
                    transition: .2s ease-in;
                    will-change: transform;
                    box-sizing: border-box;
                    &:hover{
                        color: #a7cf38;
                        border-color: #a7cf38;                        
                    }
                }

                .swiper-button-next{
                    &::before{
                        content: "\f14f";
                    }
                    margin-left: 18px;
                }                
                .swiper-button-prev{
                    &::before{
                        content: "\f14a";
                    }
                    margin-left: 18px;
                }                
            }
        }    
}
@media only screen and (max-width: 991px) {
    .home-slider{
        .swiper-slide-caption{ 
            left:0;
            max-width: 350px;
            .swiper-box{
                margin: 2rem 3rem 2rem 2rem;
                p{
                    color: #080808;
                    font-size: 1.2rem;
                }                
            }

            .animated-bg{
                background-color: rgba(247, 247, 247, 0.7);
            }
        }
    }
}

@media only screen and (max-width: 768px) {
    .home-slider{
        margin-top:104px;

        .vue-load-image{
            height: 200px;
            .lds-roller{
                bottom: 250px;
            }
        }
        .background-image{
            height: 200px;   
            background-position: center center; 
        }

        .swiper-slide-caption{ 
            left:0;
            max-width: 100%;
            width:100%;
            height: auto;
            min-height: 200px;
            position: relative;
            .swiper-box{
                margin: 0rem 1rem;
                .text-animation-container{
                    h3{
                        font-weight: 600;
                        font-size: 1.4rem;
                        color: #080808;
                        margin-top: 1rem;
                    }
                    p{
                        color: #292929;
                        line-height: 1.5;
                        font-weight: 400;
                        letter-spacing: .05em;
                        font-size: 14px;
                        font-weight: 600;
                        margin-top: .5rem;
                    }
                }

                .button-wrap{
                    bottom:0rem;
                    margin-bottom: 1rem;
                    a{
                        font-size: 12px;
                        padding: 20px 50px 20px 20px; 
                        letter-spacing: 0.1em;                        
                        span{
                            width: 35px;
                        }
                    }
                }                
            }
        }
        .swiper-nav{
            text-align: center;
            padding: 1rem 2rem;
            position: relative;
            vertical-align: text-bottom;
            background: #efefef;
            .swiper-arrows{
                width: 100%;
                height: 48px;
                margin:0;
                .swiper-button-prev, .swiper-button-next{
                    position: absolute;
                    margin: 0;
                }
                .swiper-button-prev{
                    left:0;
                }
                .swiper-button-next{
                    right:0;
                }                
            }
            .swiper-nav-numbers{
                width: 100%;
                position: absolute;
                margin: 0;
                padding: 0;
                left: 0;
                top: 0;
                bottom: 0;
                height: 48px;
                margin: auto;    

                .swiper-pagination__fraction-index{
                    font-size: 48px;
                }
            }

        }
    }
}

.fade-enter-active,
.fade-leave-active{
    opacity: 0;
}
.fade-enter,
.fade-leave-to{
    opacity: 0;
}

.slideInLeft-enter-active,
.slideInLeft-leave-active{
	-webkit-animation-name: slideInLeft;
    animation-name: slideInLeft;
    animation-duration: .7s;
    animation-fill-mode: both;    
}
.slideInLeft-enter,
.slideInLeft-leave-to{
    display: none;
}

.slideInRight-enter-active,
.slideInRight-leave-active{
    animation-name: slideInRight;
    animation-duration: .7s;
    animation-fill-mode: both;    
}
.slideInRight-enter,
.slideInRight-leave-to{
    display: none;
}

.slideInDown-enter-active,
.slideInDown-leave-active{
    animation-name: slideInDown;
    animation-duration: .7s;
    animation-fill-mode: both;    
}
.slideInDown-enter,
.slideInDown-leave-to{
    display: none;
}

.slideInUp-enter-active,
.slideInUp-leave-active{
    animation-name: slideInUp;
    animation-duration: .5s;
}
.slideInUp-enter,
.slideInUp-leave-to{
    display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/Slider/ImageSlider.vue